import TecPastSessionsOnboarding from "./TecPastSessionsOnboarding";

export default TecPastSessionsOnboarding;
